import Button from "components/button/button";
import Input from "components/input/input";
import InputMultilineField from "components/input/input-multiline";
import { Context } from "context/context";
import _ from "lodash";
import { useContext, useState } from "react";
import { CONTACTOBJ } from "utils/constant";

export default function HubspotFormDetails({
  handleChangeStep,
  state,
  setState,
  handleOnSave,
}) {
  const { setSelectedTab, popup } = useContext(Context);
  const [content, setContent] = useState(
    _.isEmpty(popup?.contact_method_content)
      ? _.find(CONTACTOBJ, { type: "hubspot-form" })
      : JSON.parse(popup?.contact_method_content)
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const update = {
      [name]: value,
      portalId: "",
      formId: "",
      region: "",
    };
    if (name === "embed") {
      let portalId = value.match(/portalId:\s+['"](.+)['"]/)?.[1];
      if (portalId) {
        update["portalId"] = portalId;
        update["newStyle"] = false;
      }
      let formId = value.match(/formId:\s+['"](.+)['"]/)?.[1];
      if (formId) {
        update["formId"] = formId;
        update["newStyle"] = false;
      }
      portalId = value.match(/data-portal-id=['"](\d+)['"]/)?.[1];
      if (portalId) {
        update["portalId"] = portalId;
        update["newStyle"] = true;
      }
      formId = value.match(/data-form-id=['"]([-\w]+)['"]/)?.[1];
      if (formId) {
        update["formId"] = formId;
        update["newStyle"] = true;
      }
      let region = value.match(/data-region=['"](\w+)['"]/)?.[1];
      if (region) {
        update["region"] = region;
        update["newStyle"] = true;
      }
    }
    setContent((prev) => ({
      ...prev,
      ...update,
    }));
    setState((prev) => ({
      ...prev,
      validationErrors: { ...state.validationErrors, [name]: null },
    }));
  };

  return (
    <div className="w-full">
      {/* header */}
      <div className="w-full">
        <p className="font-medium text-2xl">Complete Your Contact Details</p>
      </div>
      {/* end header */}
      <div className="w-full pt-5">
        {/* left card start */}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleChangeStep(content);
          }}
          className="w-full bg-white rounded-xl relative campaign-left-max mr-32"
          style={{ height: "fit-content" }}
        >
          <div className="p-5">
            <p className="text-xl pl-1 pb-2">Embed your HubSpot form</p>
            {/* middle */}
            <div>
              <p className="pl-1 pt-2 pb-2">
                Enter your HubSpot embed code here:
              </p>
              {/* title */}
              <div>
                <InputMultilineField
                  inputContainerClass="input-container"
                  outsideLabelClass="sr-only"
                  paddingTop="1.5rem"
                  value={content.embed}
                  maxLength={1000}
                  outsideLabel="Embed Code"
                  autoFocus={true}
                  name="embed"
                  onChange={handleInputChange}
                  onBlur={() => handleOnSave(content)}
                  errorMessage={state.validationErrors?.embed}
                />
              </div>
              <Input
                inputContainerClass="input-container"
                labelClass="input-label-xs"
                paddingTop="1.5rem"
                value={content.portalId}
                maxLength={255}
                label="Portal ID"
                name="portalId"
                errorMessage={state.validationErrors?.portalId}
                type="text"
                disabled
              />
              <Input
                inputContainerClass="input-container"
                labelClass="input-label-xs"
                paddingTop="1.5rem"
                value={content.formId}
                maxLength={255}
                label="Form ID"
                autoFocus={true}
                name="formId"
                errorMessage={state.validationErrors?.formId}
                type="text"
                disabled
              />
              <Input
                inputContainerClass="input-container"
                labelClass="input-label-xs"
                paddingTop="1.5rem"
                value={content.region}
                maxLength={255}
                label="Region"
                name="region"
                errorMessage={state.validationErrors?.region}
                type="text"
                disabled
              />
            </div>
            <p className="text-sm">
              Need help?{" "}
              <a
                className={"text-blue font-bold underline"}
                target={"_blank"}
                href="https://support.conversioncow.com/hc/en-us/articles/11862984353039-How-to-Add-a-Hubspot-Form-Popout-beta"
                rel="noreferrer"
              >
                Find out more
              </a>
            </p>
          </div>
          {/* footer */}
          <div className="border-t border-tabBorder">
            <div className="flex flex-row flex-1 justify-end p-5 space-x-10">
              <Button
                buttonName="PREVIOUS"
                buttonClass="bg-transparent rounded-full py-3"
                buttonType="transparent"
                buttonTextClass="text-sm font-bold"
                onClick={() => setSelectedTab("contactM")}
              />
              <Button
                buttonName="NEXT"
                buttonClass="relative bg-primary rounded-full py-3 px-12"
                buttonType="primary"
                type="submit"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
